export const TREE = 'layerData'
export const BRANCH = 'layers'
